const PaymentList = () => import(/* webpackChunkName: "PlayerList" */ './containers/PaymentGrid.vue');

export const paymentRouting = [
    {path: '/payment', name: 'payment-list', component: PaymentList},
]
